export default __webpack_public_path__ + "img/zumper_logo.91f43aea.svg";